<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">lock_open</v-icon>
          <span class="headline ml-2 white--text"
            >Access logs
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon small class="white--text" v-on="on">help</v-icon>
              </template>
              <div>
                This section provides an audit logs of all access changes
              </div>
            </v-tooltip>
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <div class="body-2 ml-2 my-2">
            <div>Here we log all the access changes for audit.</div>
          </div>

          <v-data-table
            :headers="headers"
            :items="accessRequests"
            class="elevation-0 row-pointer"
            hide-default-footer
            dense
          >
            <template v-slot:no-data
              >You have not made any access changes yet !!</template
            >
            <template v-slot:footer>
              <div class="text-center mt-5">
                <v-btn
                  fab
                  small
                  depressed
                  class="theme"
                  @click="previous"
                  :disabled="pagination.page <= 0"
                >
                  <v-icon small>navigate_before</v-icon>
                </v-btn>
                <span>
                  <v-btn text :disabled="true">{{ pagination.page + 1 }}</v-btn>
                </span>
                <v-btn
                  fab
                  small
                  depressed
                  class="theme"
                  @click="next"
                  :disabled="pagination.disableNext"
                >
                  <v-icon small>navigate_next</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
import { TableHeaders } from "@/views/headers";

export default {
  name: Component.Protected.Company.Access.Logs,
  data: () => ({
    breadcrumbs: Breadcrumbs.Access.Logs,
    headers: TableHeaders.Access.Log,
    requests: [],
    pagination: {
      disableNext: true,
      page: 0,
    },
    search: {
      name: "",
      limit: 499,
      offset: 0,
    },
  }),
  computed: {
    ...mapGetters(["userInfo", "accessRequests"]),
  },
  methods: {
    setup() {
      this.$store.dispatch(Actions.Auth.AccessRequestList, this.search);
    },
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.requests.length >= this.search.limit) {
        this.pagination.disableNext = false;
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getRequests();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.pagination.disableNext = false;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getRequests();
      }
    },
  },
  created() {
    if (!this.userInfo || this.userInfo.role !== Constants.Roles.HR) {
      this.$router.go(-1);
    }
    this.setup();
  },
};
</script>

<style scoped>
.v-tooltip__content {
  margin-left: 0 !important;
  background: #fff;
  color: #551738;
}
</style>